@if (open()) {
  <div class="nf-overlay" (click)="onClose()"></div>

  <aside class="nf" role="dialog" aria-label="Create feedback">
    <!-- header -->
    <header class="nf-head">
      <button class="nf-close" type="button" (click)="onClose()" aria-label="Close" [disabled]="submitting()">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"
          stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </button>
      <div class="nf-title">New Feedback</div>
      <div class="nf-subtitle">Log a finding for this project.</div>
    </header>

    <!-- scrollable body -->
    <form class="nf-body" (submit)="$event.preventDefault(); onSubmit()">
      <!-- identification -->
      <div class="nf-field">
        <label class="nf-label" for="nf-element">Element <span class="req">*</span></label>
        <input
          id="nf-element"
          class="nf-input"
          type="text"
          placeholder="e.g. Header navigation"
          [value]="element()"
          (input)="setField('element', $event)"
          [disabled]="submitting()"
        />
      </div>

      <div class="nf-field">
        <label class="nf-label" for="nf-url">URL <span class="req">*</span></label>
        <input
          id="nf-url"
          class="nf-input mono"
          type="text"
          placeholder="https://example.com/page"
          [value]="url()"
          (input)="setField('url', $event)"
          [disabled]="submitting()"
        />
      </div>

      <div class="nf-field">
        <label class="nf-label" for="nf-screen">Screen <span class="req">*</span></label>
        <select
          id="nf-screen"
          class="nf-input"
          [value]="screen()"
          (change)="setField('screen', $event)"
          [disabled]="submitting()"
          required
        >
          <option value="" disabled hidden>Select a screen…</option>
          @for (option of screenOptions; track option.value) {
            <option [value]="option.value">{{ option.label }}</option>
          }
        </select>
      </div>

      <!-- content -->
      <div class="nf-field">
        <label class="nf-label" for="nf-observation">Observation <span class="req">*</span></label>
        <textarea
          id="nf-observation"
          class="nf-input"
          rows="4"
          placeholder="Describe what was observed…"
          [value]="observation()"
          (input)="setField('observation', $event)"
          [disabled]="submitting()"
        ></textarea>
      </div>

      <div class="nf-field">
        <label class="nf-label" for="nf-recommendation">Recommendation</label>
        <textarea
          id="nf-recommendation"
          class="nf-input"
          rows="3"
          placeholder="Suggest a fix or next step (optional)…"
          [value]="recommendation()"
          (input)="setField('recommendation', $event)"
          [disabled]="submitting()"
        ></textarea>
      </div>

      <!-- screenshot -->
      <div class="nf-field">
        <label class="nf-label">Screenshot</label>

        @if (screenshotPreview(); as preview) {
          <div class="nf-shot">
            <img [src]="preview" alt="Screenshot preview" />
            <button class="nf-shot-remove" type="button" (click)="removeScreenshot()" [disabled]="submitting()" aria-label="Remove screenshot">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"
                stroke-linecap="round" stroke-linejoin="round">
                <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
              </svg>
            </button>
          </div>
        } @else {
          <label
            class="nf-drop"
            [class.over]="dragOver()"
            (dragover)="onDragOver($event)"
            (dragleave)="onDragLeave()"
            (drop)="onDrop($event)"
          >
            <input type="file" [accept]="acceptAttr" (change)="onFileSelected($event)" [disabled]="submitting()" hidden />
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"
              stroke-linecap="round" stroke-linejoin="round">
              <rect x="3" y="3" width="18" height="18" rx="2" /><circle cx="9" cy="9" r="2" />
              <path d="m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21" />
            </svg>
            <div class="nf-drop-main">Drop a screenshot here</div>
            <div class="nf-drop-sub">or click to browse · PNG, JPG, WEBP up to 5 GB</div>
          </label>
        }

        @if (screenshotError(); as error) {
          <div class="nf-error">{{ error }}</div>
        }
      </div>
    </form>

    <!-- footer -->
    <footer class="nf-foot">
      <button class="nf-btn ghost" type="button" (click)="onClose()" [disabled]="submitting()">Cancel</button>
      <button class="nf-btn primary" type="button" (click)="onSubmit()" [disabled]="!valid() || submitting()">
        @if (submitting()) {
          <span class="nf-spinner" aria-hidden="true"></span> Creating…
        } @else {
          Create Feedback
        }
      </button>
    </footer>
  </aside>
}
